import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.PAYMENT_METHOD_SET_PAYMENT_METHOD_LIST]: (state, payload) => {
    state.paymentMethodList = payload.paymentMethodList

    const sortNumberList = payload.paymentMethodList.map((ele) => {
      return ele.sortNumber
    })

    if (sortNumberList.length) {
      state.maxSortNumber = Math.max(...sortNumberList)
    }
  }
}

export default Mutations
